
<template>
  <v-dialog max-width="600px" v-model="showDialog">
    <v-btn flat fab slot="activator" style='margin-top:-20px' 
        class="indigo accent-1"
        light small mt-4 absolute middle right ><v-icon>add</v-icon></v-btn>

    <v-card>
      <v-card-title>
        <h2>Define a new rank</h2>
      </v-card-title>
      <v-card-text>
        <v-form ref="form">
          <v-layout mx-3 my-3 column>
            <v-flex xs6 offset-xs0>
               <v-layout row>
                <v-flex xs6>
                  <v-text-field  v-if="showDialog" autofocus v-model="newRank.name" name='rankName' label="Rank Name"
                    :rules="[rules.required, rules.min]" />
                </v-flex>
                <v-flex xs6 ml-2>
                  <v-select box label="Service" name='service' v-model="newRank.type" item-text='v' item-value='code'
                    :items=serviceValues></v-select>
                </v-flex>
              </v-layout>
              <provenance-and-note v-bind:record="newRank"/>
              <v-layout row>
                <v-flex xs12>
                  <div class="error" v-html="error"></div>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs12>
                  <v-btn dark class="indigo darken-1" @click='createRank' :loading="loading"><v-icon left >save_alt</v-icon> Define New Rank</v-btn>
                </v-flex>
              </v-layout>         
            </v-flex>
          </v-layout>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>        

<script>

import Panel from '@/components/Panel' ;
import RankService from "@/services/RankService" ;

export default {
  components: { Panel },
  data () {
    return {
      newRank: {  
        name: '',
        type: 'ra',
        provenance: '',
        note: ''
      },
      error: null,
      rules: {
        required: value => !!value || 'Required.',
        min: v => v.length >= 8 || 'Minimum of 8 characters is required.'
      },
      serviceValues: [{code:'ra', v:'Army'},
        {code:'rd', v:'Merchant Navy'},
        {code:'rc', v:'RAAF'},
        {code:'rb', v:'RAN'}
      ],
      loading: false,
      showDialog: false
    }
  },

  methods: {
    async createRank () {

      console.log("IN createRank") ; 
      if (!this.$refs.form.validate()) return ;
      this.error = '' ;
      try {
        this.loading = true ;
        const response = await RankService.create(this.newRank) ;
        console.log("createRank response: " + JSON.stringify(response)) ;
        this.showDialog = false ;
        this.$renderToastInParent(this, "Rank " + this.newRank.name + " successfully created") ;
      }
      catch (err) {
        console.log("catch err:" + err) ;
        this.error = err.response.data.error 
      }
      finally {
        this.loading = false ;
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/RankCreate.vue